module.exports = __webpack_public_path__ + "static/img/bracelets-spec-pc.2ec18fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bracelets-spec-pc.jpg
// module id = cEhj
// module chunks = 1